/**
 * ⑭ 킬 스위치 분기 한 곳 — v2=true 면 NavV2(서버 렌더), false 면 호출부가 넘긴 옛 탐색(legacy)을 «그대로».
 * 값은 (main)/layout 이 app_config ui/nav_v2 에서 서버로 읽어 내려준다(방문자 전원 같은 값 · 쿠키 0).
 */
import type { ReactNode } from 'react';
import NavV2 from './NavV2';

export default function NavSwitch({ v2, pathname, legacy }: { v2: boolean; pathname: string; legacy: ReactNode }) {
  return v2 ? <NavV2 pathname={pathname} /> : <>{legacy}</>;
}
